<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
	import {
		removeCookie
	} from '@/utils/cookie'
export default {
  name: "App",
  beforeDestroy() {
    console.log("当前地址"+this.$route.path);
    if (this.$route.path !== '/gesso' || this.$route.path !== '/enterprise-login') {
        removeCookie('SRC');
      }
  },
 methods: {
    
  }
};
</script>
